module.exports = __webpack_public_path__ + "img/contact_address.45d0d60c.png";